'use client';

import { FC } from 'react';
import styles from './event-badge.module.css';
import { IcoMoonIcon } from '../../../../../packages/ui/components/icons';
import { cn } from '@wwe-portal/ui/lib/lib';
import { useTranslations } from 'next-intl';
import { useTimeLeft } from '../../../../../packages/ui/lib/hooks';
import { formatThousands } from '@wwe-portal/utils/format';

interface EventStatisticBadgeProps {
  point: number | undefined;
  label: string;
  variant?: 'points' | 'participants';
}

export const EventStatisticBadge: FC<EventStatisticBadgeProps> = ({
  point,
  label,
  variant = 'points',
}) => {
  const iconName = variant === 'participants' ? 'user-add-fill' : 'medal-fill';

  const formattedPoint = point !== undefined ? formatThousands(point) : '';

  return (
    <div className={cn('min-w-[180px] gap-2', styles.badge)}>
      <IcoMoonIcon className="text-yellow800 h-6 w-6" iconName={iconName} />
      <div className="flex flex-col">
        <span className="text-sm font-semibold">{formattedPoint}</span>
        <span className="text-xs">{label}</span>
      </div>
    </div>
  );
};

export const CountdownBadge: FC<{ endDate: string }> = ({ endDate }) => {
  const t = useTranslations();
  const { getTimeText, ended } = useTimeLeft(endDate);
  return (
    <div className={cn('min-w-[150px] gap-2', styles.badge)}>
      <IcoMoonIcon iconName="timer" className="h-6 w-6" />
      <span>{ended ? t('event_ended') : getTimeText(' ', 3)}</span>
    </div>
  );
};
